import { gql } from '@apollo/client';
export const UpdateSubTypeIsRequiredMutation = gql `
    mutation UpdateSubTypeIsRequired($siteSetId: InstitutionSetId!, $subTypeIsRequired: Boolean!) {
        staffhours {
            settings {
                updateSubTypeIsRequired(siteSetId: $siteSetId, subTypeIsRequired: $subTypeIsRequired)
            }
        }
    }
`;
